import React from 'react';
import { ProductColor } from '../../../integrations/relewise/types/mapped';
import { Skeleton } from '../skeleton/skeleton';

const MAX_VISIBLE = 3;

interface Props {
    colors: ProductColor[] | undefined;
    isLoading?: boolean;
}
export const ColorPalettePreview = ({ colors, isLoading = false }: Props) => {
    const visible = colors?.slice(0, MAX_VISIBLE) || [];
    const remaining = colors?.length ? colors.length - MAX_VISIBLE : 0;

    if (isLoading) {
        return (
            <div className='color-palette-preview'>
                <Skeleton className='color-palette-preview__swatch color-palette-preview__swatch--loading' />
                <Skeleton className='color-palette-preview__swatch color-palette-preview__swatch--loading' />
                <Skeleton className='color-palette-preview__swatch color-palette-preview__swatch--loading' />
            </div>
        );
    }

    return (
        <div className='color-palette-preview'>
            {visible.map(color => (
                <span key={color.hex} className='color-palette-preview__swatch' style={{ backgroundColor: color.hex }} title={color.name} />
            ))}
            {remaining > 0 && <span className='color-palette-preview__overflow'>+{remaining}</span>}
        </div>
    );
};
